// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38gsU","type":"styles_type__1Lnb6","choices":"styles_choices__2G3rk"};